import "./Sidebar.css";
import React, { useContext, useState } from "react";
import { NavLink } from "react-router-dom";
import {
  Collapse,
  Divider,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Toolbar,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { AuthContext } from "../../../auth/authContext";
import { dashboardPath } from "../dashboardPath";

const Sidebar = ({ drawerWidth }) => {
  const [openMenus, setOpenMenus] = useState({ 订单: true });
  const authContext = useContext(AuthContext);

  const handleClickMenu = (pathName) => {
    const newOpenMenus = { ...openMenus };
    newOpenMenus[pathName] = !newOpenMenus[pathName];
    setOpenMenus(newOpenMenus);
  };

  const listMenu = () => {
    if (!authContext) {
      return [];
    }
    const dashboard = dashboardPath(
      authContext.isAdmin(),
      authContext.isBA(),
      authContext.isWarehouse(),
      authContext.isCustomer(),
      authContext.isFinance(),
      authContext.isPurchaser(),
      authContext.isSalesScopeRole(),
    );
    return dashboard.map((path) => {
      const subMenus = path.subPaths.map((subPath) => {
        const auths = subPath.auths;
        return auths ? (
          <ListItemButton
            key={subPath.path}
            sx={{ pl: 4 }}
            component={NavLink}
            to={`/dashboard/${subPath.path}`}
          >
            <ListItemText key={subPath.path} primary={subPath.name} />
          </ListItemButton>
        ) : null;
      });
      const filteredSubMenus = subMenus.filter((m) => m !== null);
      if (filteredSubMenus.length === 0) {
        return null;
      }
      return (
        <div key={path.name}>
          <ListItemButton onClick={() => handleClickMenu(path.name)}>
            <ListItemText primary={path.name} />
            {openMenus[path.name] ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={openMenus[path.name]} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {filteredSubMenus}
            </List>
          </Collapse>
        </div>
      );
    });
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: "border-box" },
      }}
    >
      <Toolbar />
      <Divider />
      <List>{listMenu().filter((m) => m !== null)}</List>
      <Divider />
      {/* 其他可能的部分 */}
    </Drawer>
  );
};

export default Sidebar;
